/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import map from '../static/map.png'
import {
  Header,
  HeaderParagraph,
  Product,
  Backgroundwrapper,
  Footer,
  OurClient,
  ProductDescription,
  MobileFooter,
  BodyWrapper,
  Input,
  Icon
} from '../components'
import { Element } from 'react-scroll'
import { Container, BigCircle, Font51, Font20, Font16, Href, Font14Tag } from '../components/StyledComponents'
const MobileClientLogo = styled.li``
const ContentWrapper = styled.div`
  max-width: 2560px;
  margin: 0 auto;
`

const ProductCards = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: 1366px;
  @media (max-width: 768px) {
    & > div {
      width: calc(50% - 24px);
      margin: 0px auto;
      padding: 20px;
      margin:12px;
      
    }
    @media (max-width: 520px) {
      & > div {
        width: 100%;
      }
  }
`
const Container2 = styled.section`
  padding: ${props => (props.padding ? props.padding : '60px 80px')};
  background: ${props => (props.background ? props.background : '#fff')};
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.normal ? 'normal' : 'center')};
  margin: ${props => (props.margin ? props.margin : '0px')};
  width: 100%;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 20px;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const ContainerSubTitle = styled.p`
font-size: 1rem;
    line-height: 1.5rem;
  text-align: center;
  color: #999999;
  padding-top: 8px;
  width: calc(100% - 0%);
  padding-left: 15%;
  padding-right: 15%;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 300;
    padding: 0;
    line-height: 1.63;
  }
  @media (max-width: 520px) {
  padding: 0;
`
const ContainerTitle = styled.h1`
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-weight: 500;
  text-align: ${props => (props.align ? props.align : 'center')};
  color: #000;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`
const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 40px;

  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }

  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
`
const ImageWrapper = styled.div`
  & > img {
    width: 360px;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    & > img {
      width: 300px;
    }
  }
`
const FormWrapper = styled.form`
  display: flex;
  padding-top:20px;
  @media (max-width: 520px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    & > div > input {
      width: 100%;
      margin-bottom: 10px;
    }
    & > button {
      width: 100%;
      border-radius 4px;
    }
  }
`
const ButtonComponent = styled.button`
  width: ${props => (props.width ? props.width : 186)}px;
  height: ${props => (props.height ? props.height : 48)}px;
  background: ${props => (props.background ? props.background : '#333333')};
  border-radius: ${props => (props.radius ? props.radius : '4px')};
  border: ${props => (props.border ? props.border : 'none')};
  line-height: 1;
  letter-spacing: 1px;
  color: ${props => (props.color ? props.color : '#fff')};
  cursor: pointer;
  text-transform: ${props => (props.transform ? props.transform : 'uppercase')};
  font-family: Montserrat;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 1px;
  box-shadow: ${props => (props.shadow ? props.shadow : 'none')};
  -webkit-tap-highlight-color: transparent;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  }
  &:focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    outline: none;
  }
  @media (max-width: 768px) {
    height: 38px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
  }
`
const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: ${props => (props.alignItem ? 'flex-start' : 'center')};
  padding: ${props => (props.padding ? props.padding : 0)};
  @media (max-width: 992px) {
    flex-direction: column;
    width: 100%;
  }
  @media (max-width: 768px) {
    & > div {
      flex-basis: 100%;
      width: 100%;
    }
  }
`
const FromGroup = styled.div`
  width: 100%;
  margin-right: 20px;
  margin: 8px;
  input,
  textarea {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    width: 100%;
  }
  input {
  }
  textarea {
    padding: 10px;
    min-height: 150px;
    :focus {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
      outline: none;
    }
  }
`
const ContactFrom = styled.div`
  margin-top: 50px;
`
const AddressWrap = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  margin-top: 20px;
  margin-left: 30px;

  @media (max-width: 768px) {
    margin-left: 0px;
  }
`
const AddressContent = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
  a {
    color: #000;
  }
  > span {
    margin-right: 10px;
  }
  p {
    font-size: 14px;
    color: #555;
    font-weight: 500;
    margin-bottom: 5px;
  }
  p span {
    font-weight: bold;
    display: block;
    font-size: 16px;
    color: #000;
  }
`
const HorizontalLine = styled.hr`
  width: 100%;
  border-width: 1px 0 0 0;
  margin: 20px 0 0 0;
  border-color: #fffefe;
`
const ListOuter = styled.div`
  padding: 0 32px 0 0;
  & p {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  @media (max-width: 768px) {
    padding: 0;
  }
`
const ListWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  @media (max-width: 768px) {
    padding-bottom: 40px;
  }
  @media (max-width: 520px) {
    flex-direction: column;
    padding-bottom: 40px;
  }
`
const ListItem = styled.li`
  width: 50%;
  list-style: none;
  display: flex;
  padding: 40px 40px 0px 0;
  & > div {
    padding: 0 0 0 8px;
  }
  &::before {
    content: '■';
    font-size: 20px;
    color: #f0425f;
    width: 46px;
  }
  & h4 {
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;
    color: #000;
  }
  & p {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  @media (max-width: 768px) {
  }
  @media (max-width: 520px) {
    width: 100%;
    padding: 24px 0 0 0;
  }
`
export const Button = props => {
  return (
    <ButtonComponent
      color={props.color}
      height={props.height}
      width={props.width}
      background={props.background}
      border={props.border}
      radius={props.radius}
      {...props}>
      {props.title}
    </ButtonComponent>
  )
}

class DataMining extends Component {
  state = {
    collapse: false,
    MobileLogo: true,
    MobileLogoText: 'View More',
    selected: 'V'
  }
  render() {
    const { selected } = this.state
    console.log(selected)
    return (
      <Fragment>
        <Header />
        <ContentWrapper>
          <Container background="#1E40AF" padding={'60px 80px'} flexDirection="row">
            <TopWrapper>
              <HeaderParagraph
                headerColor={'#fff'}
                headerFontSize={'2.25rem'}
                headerLineHeight={'2.5rem'}
                headerParaColor={'#bfdbfe'}
                header={'Web Crawling Service for the Enterprise'}
                paragraph={
                  'Customizable and Scalable Platform and Services for Enterprise Web Scraping. You don’t have to worry about setting up servers and web crawling tools or software. We provide the best web scraping service and do everything for you. Just tell us what data you need and we will manage the data crawling for you'
                }
              />
            </TopWrapper>
            <ImageWrapper>
              <img src={require('../static/web-crawling_site.png')} alt="Services" />
            </ImageWrapper>
          </Container>
          <Container padding={'80px 80px 50px 80px'} background="transparent">
            <Font51>What we do</Font51>
            <Font20 bottomPadding={'12px'}>We get fresh clean web data for your organization</Font20>
            <ProductCards>
              <ProductDescription
                icon={'serviceicon2/iconLead.svg'}
                title="Lead Generation Data"
                width="50"
                description="Tell us where your ideal customers can be found (e.g. Crunchbase, Yelp) and we will collect the data you need to build targeted prospecting campaigns."
              />
              <ProductDescription
                icon={'serviceicon2/iconPricing.svg'}
                title="Pricing & Competitive Data"
                width="50"
                description="Get pricing, categories, inventory and other crucial information about your competitors you need to adjust your retail"
              />

              <ProductDescription
                icon={'serviceicon2/iconMarket.svg'}
                title="Financial & Market Data"
                width="50"
                description="We help you to scour financial information, market trends and industry topics to pinpoint the companies you need to know or do business with."
              />
              <ProductDescription
                icon={'serviceicon2/iconDistribution.svg'}
                title="Distribution Chain Monitoring"
                width="50"
                description="Understand what's selling and what isn't by tracking how your products are placed or promoted on your distributors' or retailers' websites."
              />
            </ProductCards>
          </Container>

          <Container padding={'80px 80px 50px 80px'} background="#fafafa">
            <FlexContainer>
              <div>
                <Font16 textAlign="left">Data Extraction Service</Font16>
                <Font51 textAlign="left" maxWidth={'800px'}>
                  Custom data extraction for projects of any size
                </Font51>
              </div>
            </FlexContainer>
            <HorizontalLine />
            <FlexContainer padding={'44px 0 0 0'} alignItem>
              <ListOuter>
                <p>
                  Our web scraping experts can build and maintain the ideal extraction solution with our web scraping
                  tool to drive your business forward. Quickly and reliably, whether you’re starting out, scaling up or
                  in the big league.
                </p>
                <ListWrapper>
                  <ListItem>
                    <div>
                      <h4>Audited Data</h4>
                      <p>The data being delivered is audited by our QA team.</p>
                    </div>
                  </ListItem>
                  <ListItem>
                    <div>
                      <h4>8+ Years of Expertise</h4>
                      <p>Get access to our team and leverage our company's expertise </p>
                    </div>
                  </ListItem>
                  <ListItem>
                    <div>
                      <h4>Done for you</h4>
                      <p>Just tell us what you need, we will figure out how and everything else.</p>
                    </div>
                  </ListItem>
                  <ListItem>
                    <div>
                      <h4>Deterministic Pricing</h4>
                      <p>
                        Our pricing will be based directly on the deliverables and you can easily estimate the costs if you plan to increase the workload. 
                      </p>
                    </div>
                  </ListItem>
                  <ListItem>
                    <div>
                      <h4>Your extended team</h4>
                      <p>We ensure that your needs are fulfilled and adapt with the changes occurring in your organization</p>
                    </div>
                  </ListItem>
                </ListWrapper>
              </ListOuter>
            </FlexContainer>
          </Container>

          <Container padding={'80px 80px 50px 80px'} background="transparent">
            <Font51>Benefits</Font51>
            <Font20 bottomPadding={'12px'}>
              Here’s what we skillfully offer to take your brand to the next level.
            </Font20>
            <ProductCards>
              <ProductDescription
                icon={'serviceicon2/highly-customizable.svg'}
                title="Highly Customizable"
                width="33.3"
                description="Code based web scraping platform allows for high customizability of web scraping scenarios."
              />
              <ProductDescription
                icon={'serviceicon2/highly-scalable.svg'}
                title="Highly Scalable"
                width="33.3"
                description="Scale your web scraping processes to millions of page requests with a few mouse clicks."
              />

              <ProductDescription
                icon={'serviceicon2/advanced-web-scraping.svg'}
                title="Advanced Web Scraping"
                width="33.3"
                description="Go beyond the limitations of point and click or browser extension tool. We can handle those difficult scenarios that those tools can’t cover."
              />
              <ProductDescription
                icon={'serviceicon2/data-cleanliness.svg'}
                title="Data Cleanliness"
                width="33.3"
                description="Enterprise grade web scraping needs high quality output. Define a set of data schemas to ensure the cleanliness of your web scraped data."
              />
              <ProductDescription
                icon={'serviceicon2/handles-anti-scraping.svg'}
                title="Handles Anti-Scraping"
                width="33.3"
                description="Most web scraping tools and software out there crumble against it, but with our massive pool of auto-rotating proxies, user agents, and secret-sauce helps get around them."
              />
              <ProductDescription
                icon={'serviceicon2/preferred-format.svg'}
                title="Choose your Preferred Format"
                width="33.3"
                description="Export your clean data in different formats fitting your specific needs. CSV / JSON or need it directly in your database? We got them covered."
              />
            </ProductCards>
          </Container>

          <Container padding={'80px 80px 50px 80px'} background="transparent">
            <Font51>How our web crawling service works</Font51>

            <ProductCards>
              <ProductDescription
                icon={'Serviceicon/requirements.png'}
                title="Requirements"
                width="33.3"
                description="You tell us what data you need to crawl and from which websites"
              />
              <ProductDescription
                icon={'Serviceicon/build-and-crawl.png'}
                title="Build and Crawl"
                width="33.3"
                description="We crawl the data using our highly distributed web crawling software"
              />
              <ProductDescription
                icon={'Serviceicon/deliver-data.png'}
                title="Deliver Data"
                width="33.3"
                description="We deliver clean usable data in your preferred format and location"
              />
            </ProductCards>
          </Container>

          <Container2 normal background={'#fafbfc'} padding={'80px 0 80px 0'}>
            <ContainerTitle>Our Clients Around The World</ContainerTitle>
            <ContainerSubTitle>
              Our clients are valuable to us and we’re always inspired by them and their need to make their business
              better.
            </ContainerSubTitle>
            <Backgroundwrapper>
              <OurClient>
                <ul>
                  <li>
                    <img src={require('../static/client_logo/wickey.jpg')} alt="Wickey.de" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/munafamart.png')} alt="Munafamart" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/beccos.jpg')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/greenchoice.png')} alt="Greenchoice" />
                  </li>
                </ul>
              </OurClient>
            </Backgroundwrapper>
          </Container2>
          <Container2 normal padding={'60px 80px'}>
            <HeaderParagraph
              alignCenter={'center'}
              headerColor={'#333333'}
              headerFontSize={'2.25rem'}
              header={'Pricing'}
              paragraph={'Please send us your requiements and we will get back to you within 24 hours.'}
            />

            <FlexContainer style={{ maxWidth: '600px', margin: 'auto' }}>
              <ContactFrom>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <FlexContainer>
                    <FromGroup>
                      <Input type="name" icon="user" name="Name" placeholder="Name" changeColor={'#35cc62'} required />
                    </FromGroup>
                    <FromGroup>
                      <Input
                        type="email"
                        name="_replyto"
                        icon="email"
                        placeholder="Email"
                        changeColor={'#35cc62'}
                        onChange={this.handleChange}
                        value={this.state.email}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <Input
                        type="phone"
                        name="contact"
                        icon="contact"
                        placeholder="Phone"
                        changeColor={'#35cc62'}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <textarea name="textarea" id="" placeholder="Your message type here" />
                    </FromGroup>
                  </FlexContainer>
                  <input type="hidden" name="_next" value="/" />
                  <FromGroup>
                    <Button type="submit" title="Submit" />
                  </FromGroup>
                </form>
              </ContactFrom>

              <AddressWrap>
                <AddressContent>
                  <span>
                    <Icon icon="email" />
                  </span>
                  <p>
                    Email
                    <span>
                      <a href="mailto:harsh@8om.io"> harsh@8om.io</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="website" />
                  </span>
                  <p>
                    Website
                    <span>8om.io</span>
                  </p>
                </AddressContent>
                {/* <AddressContent>
              <span>
                <Icon icon="location" />
              </span>
              <p>
                Location
                <span>
                  3rd Floor, Plot No. 8 Balaji Estate,
                  <br /> Guru Ravidas Marg, Kalkaji,
                  <br /> New Delhi, Delhi 110019
                </span>
              </p>
           </AddressContent> */}
              </AddressWrap>
            </FlexContainer>
          </Container2>
        </ContentWrapper>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}
export default withRouter(DataMining)



// WEBPACK FOOTER //
// ./src/pages/DataMining.js